/**
 * Display names for caption languages are derived from their BCP-47
 * `browser_navigator_code` via the platform's CLDR data, so the client owns no
 * code -> name mapping that could drift from the server's language list. Both
 * sides speak the same codes; each renders names from the same standard.
 */
let displayNames: Intl.DisplayNames | undefined;
try {
  displayNames = new Intl.DisplayNames(["en"], { type: "language" });
} catch {
  // Intl.DisplayNames is unavailable (e.g. very old browsers); fall back to the
  // raw code below.
  displayNames = undefined;
}

/**
 * The label shown for a language option in the selector. The source language is
 * marked so the viewer can tell which language the captions are translated from.
 * An unresolvable code falls back to the raw code rather than being dropped.
 */
export function labelFor(code: string, isSource: boolean): string {
  let name = code;
  if (displayNames) {
    try {
      name = displayNames.of(code) || code;
    } catch {
      name = code;
    }
  }
  return isSource ? `${name} (source)` : name;
}
